import PropType from 'prop-types';
import { useDispatch } from 'react-redux';
import { Form } from 'react-final-form';
import Button from '../../components/01_atoms/Button';
import React from 'react';
import { TextField } from '../../components/01_atoms/FormElements';
import PlusIcon from '../../public/static/icons/plus-gifts.svg';
import GiftsForm from '../Form';
import { AddCustomPriceProduct } from '../../store/Slices/gifts/basketSlice';
import { currencySymbolPath, DEFAULT_CURRENCY, getSymbol } from '../../utils/currency';
import { composeParsers, parseLengthLimit, parseOnlyDigits } from '../../utils/formFieldParsers';
import { composeValidators, minValue, required } from '../../utils/formFieldValidators';

import styles from './index.module.scss';

const AddCustomDonationForm = ({ product, existingCustomPriceProduct = null }) => {
  const dispatch = useDispatch();
  const onSubmit = (data) => {
    dispatch(AddCustomPriceProduct({ product, amount: data.amount, existingCustomPriceProduct }));
  };
  const initialValues = {};

  if (existingCustomPriceProduct) {
    initialValues.amount = existingCustomPriceProduct.data.price[DEFAULT_CURRENCY].amount;
  }

  return (
    <GiftsForm>
      <Form
        onSubmit={onSubmit}
        initialValues={initialValues}
        render={({ handleSubmit }) => (
          <form className={styles['add-custom-donation-form']} onSubmit={handleSubmit}>
            <TextField
              name="amount"
              parse={composeParsers(parseOnlyDigits, parseLengthLimit(8))}
              validate={composeValidators(
                required('Please add a donation amount'),
                minValue(1, `Please enter an amount greater than 0`),
              )}
              icon={currencySymbolPath[DEFAULT_CURRENCY]}
              autoComplete="off"
              inputMode="numeric"
              pattern="[0-9]+"
              placeholder=" "
              aria-label={getSymbol(DEFAULT_CURRENCY)}
              infoOnPatternNotMatched="Please use numbers only"
            />

            <Button
              type="secondary"
              className=""
              data-component={`${existingCustomPriceProduct ? 'update' : 'add'}-custom-donation-button`}
            >
              {existingCustomPriceProduct ? (
                'Update'
              ) : (
                <div className="plus-icon">
                  <PlusIcon /> Add
                </div>
              )}
            </Button>
          </form>
        )}
      />
    </GiftsForm>
  );
};

AddCustomDonationForm.propTypes = {
  product: PropType.object.isRequired,
  existingCustomPriceProduct: PropType.object,
};

export default AddCustomDonationForm;
